import React from 'react';

import { Alert, Stack, Typography } from '@mui/material';

import PromoAdminRequiredIndicator from '~/components/Promo/PromoAdminRequiredIndicator';

import {
  type VoucherUserExpiryLongDurationMode,
  isVoucherUserExpiryOverTwelveMonths,
} from '~/utils/voucherUserExpiryLongDuration';

type Props = {
  isCreate: boolean;
  mode: VoucherUserExpiryLongDurationMode;
  voucherUserExpiresAt: string;
  voucherUserExpiresInDays: string;
};

export default function VoucherLongExpiryPromoAdminAlert({
  isCreate,
  mode,
  voucherUserExpiresAt,
  voucherUserExpiresInDays,
}: Props) {
  const show = isVoucherUserExpiryOverTwelveMonths({
    mode,
    voucherUserExpiresAt,
    voucherUserExpiresInDays,
  });

  if (!show) {
    return null;
  }

  if (!isCreate) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ alignItems: 'center', py: 0.75 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
        <Typography variant="body2" component="span">
          The <strong>promo-admin</strong> permission is required to create a long-lasting voucher.
        </Typography>
        <PromoAdminRequiredIndicator action="Creating a long-lasting voucher" />
      </Stack>
    </Alert>
  );
}
